import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export const KEY_CARD = {
  cardGap: 2,         // spacing units — gap between items in the row
  cardPx: 2,          // spacing units — horizontal padding
  cardPy: 2,          // spacing units — vertical padding of the row
  cardPb: 2,          // spacing units — bottom padding of the foot text
  metaGap: 1,         // spacing units — gap within the meta date section
  statusGap: 1,       // spacing units — gap within the status badge
  dotSize: 7,         // px — status indicator dot diameter
  dotGlowRadius: 3,   // px — glow ring width around the dot
  spacerMinWidth: 12, // px — minimum width of the flex spacer
} as const;

export function generateButtonSx(theme: Theme) {
  return {
    borderRadius: theme.borderRadius.pill,
    textTransform: 'none' as const,
    fontSize: theme.typography.fontSizeDescription,
    fontWeight: theme.typography.fontWeightSemiBold,
    height: theme.button.sm,
    px: 1.5,
    flexShrink: 0,
    boxShadow: `0 1px 2px ${alpha(theme.palette.common.black, 0.1)}`,
    '&:hover': {
      boxShadow: `0 1px 4px ${alpha(theme.palette.common.black, 0.15)}`,
    },
    '&:disabled': {
      opacity: 0.55,
    },
  };
}
